var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3849 0H5.59411C2.50263 0 0 2.50263 0 5.59411V14.4059C0 17.4763 2.50263 20 5.59411 20H14.4059C17.4763 20 20 17.4974 20 14.4059V5.59411C19.979 2.50263 17.4763 0 14.3849 0ZM18.4437 14.3849C18.4437 16.6141 16.6141 18.4437 14.3849 18.4437H5.59411C3.36488 18.4437 1.53523 16.6141 1.53523 14.3849V5.59411C1.53523 3.36488 3.36488 1.53523 5.59411 1.53523H14.4059C16.6351 1.53523 18.4648 3.36488 18.4648 5.59411V14.3849H18.4437Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8171 6.16223C13.5227 5.8678 13.039 5.8678 12.7445 6.16223L9.98953 8.91722L7.23454 6.16223C6.94121 5.8678 6.45641 5.8678 6.16198 6.16223C5.86756 6.45665 5.86756 6.94035 6.16198 7.23478L8.91698 9.98977L6.16198 12.7448C5.86756 13.0392 5.86756 13.5229 6.16198 13.8173C6.3092 13.9645 6.49847 14.0487 6.70878 14.0487C6.89805 14.0487 7.10836 13.9645 7.25557 13.8173L9.98953 11.0623L12.7445 13.8173C12.8917 13.9645 13.081 14.0487 13.2913 14.0487C13.4806 14.0487 13.6909 13.9645 13.8381 13.8173C14.1325 13.5229 14.1325 13.0392 13.8381 12.7448L11.0621 9.98977L13.8171 7.23478C14.1325 6.94035 14.1325 6.45665 13.8171 6.16223Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3a1ccb012d95ba7e2d8c3bea3124b16c.svg";
export { ForwardRef as ReactComponent };